// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"4174d5a7","94":"b69495f6","315":"13862c47","354":"3840a68a","373":"412575c4","481":"53eac857","488":"371f7511","499":"af7414d4","565":"c2db8721","601":"fa2e5f52","654":"0e86a76d","776":"324835c3","897":"1eeeabfd","944":"85e7480f"}[chunkId] + ".chunk.js";
};